<div class="modalUploadDocuments">
  <h1 class="title1 s-fontSize--mdl s-text--primary">
    Documentos para verificação de identidade
  </h1>
  <div class="account-status-container">
    <span class="account-status-label">Status da conta</span>

    <div class="account-status-badge" [ngClass]="is_verified ? 'verified' : 'not-verified'">
      <mat-icon class="status-icon">
        {{ is_verified ? 'verified' : 'gpp_bad' }}
      </mat-icon>

      <span class="status-text">
        {{ is_verified ? 'Verificada' : 'Não verificada' }}
      </span>
    </div>
  </div>


  <form [formGroup]="formDocuments" class="formUpload s-width-100" autocomplete="off">
    <div class="s-marginTop-mdl d-flex l-grid--between l-grid_col--wrap">

      <!-- Identification Document -->
      <div class="upload-box">
        <label class="m-titleSimple s-fontSize--sm label--document">
          Documento oficial com foto*
          <mat-icon class="info-icon"
            matTooltip="Documento de identificação pessoal do titular da conta (frente e verso). Aceitos: RG, CNH ou Passaporte."
            matTooltipPosition="right">
            help_outline
          </mat-icon>
        </label>

        <div class="document-status" [ngClass]="getDocumentStatusClass(documentsStatus.identification)">
          {{ getDocumentStatusText(documentsStatus.identification) }}
        </div>

        <ng-container *ngIf="canUpload(documentsStatus.identification); else documentStatusTemplate">
          <label class="m-button m-button--outline m-button--upload s-width-100" for="uploadIdentification">
            {{ preview.identificationFile ? "Arquivo anexado" : "Selecionar documento" }}
            <svg class="c-icon">
              <use xlink:href="#ic-arrow-upload" />
            </svg>
            <input accept=".jpg,.jpeg,.png,.pdf" id="uploadIdentification" type="file"
              (change)="onFileChange($event, 'identificationFile')" />
          </label>

          <div class="m-pageRegisterLot_uploadedFiles s-marginTop-sm" *ngIf="preview.identificationFile">
            <div class="m-pageRegisterLot_fileDisplay">
              <span class="m-pageRegisterLot_fileDisplay__name">
                {{ preview.identificationFile.fileName }}
              </span>
              <button class="m-pageRegisterLot_fileDisplay__btn" (click)="removeFile('identificationFile')"
                type="button">
                <svg class="c-icon">
                  <use xlink:href="#ic-garbage-close" />
                </svg>
              </button>
            </div>
          </div>
        </ng-container>

        <ng-template #documentStatusTemplate>
          <div *ngIf="documentsStatus.identification === 'rejected' ||
              documentsStatus.identification === 'requested'" class="s-marginTop-sm">

            <label class="m-button m-button--outline m-button--upload s-width-100" for="uploadIdentification">
              {{ preview.identificationFile ? "Arquivo anexado" : "Enviar novamente" }}
              <svg class="c-icon">
                <use xlink:href="#ic-arrow-upload" />
              </svg>
              <input accept=".jpg,.jpeg,.png,.pdf" id="uploadIdentification" type="file"
                (change)="onFileChange($event, 'identificationFile')" />
            </label>

            <div class="m-pageRegisterLot_uploadedFiles s-marginTop-sm" *ngIf="preview.identificationFile">
              <div class="m-pageRegisterLot_fileDisplay">
                <span class="m-pageRegisterLot_fileDisplay__name">
                  {{ preview.identificationFile.fileName }}
                </span>
                <button class="m-pageRegisterLot_fileDisplay__btn" (click)="removeFile('identificationFile')"
                  type="button">
                  <svg class="c-icon">
                    <use xlink:href="#ic-garbage-close" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>



      <!-- Selfie -->
      <div class="upload-box">
        <label class="m-titleSimple s-fontSize--sm label--document">
          Foto selfie com o documento*
          <mat-icon class="info-icon"
            matTooltip="Selfie do titular segurando o documento. Deve ser tirada pela própria pessoa, sem ajuda de terceiros, com boa iluminação."
            matTooltipPosition="right">
            help_outline
          </mat-icon>
        </label>

        <div class="document-status" [ngClass]="getDocumentStatusClass(documentsStatus.selfie)">
          {{ getDocumentStatusText(documentsStatus.selfie) }}
        </div>

        <ng-container *ngIf="canUpload(documentsStatus.selfie); else selfieStatusTemplate">
          <label class="m-button m-button--outline m-button--upload s-width-100" for="uploadSelfie">
            {{ preview.selfieFile ? "Arquivo anexado" : "Selecionar documento" }}
            <svg class="c-icon">
              <use xlink:href="#ic-arrow-upload" />
            </svg>
            <input accept=".jpg,.jpeg,.png" id="uploadSelfie" type="file"
              (change)="onFileChange($event, 'selfieFile')" />
          </label>

          <div class="m-pageRegisterLot_uploadedFiles s-marginTop-sm" *ngIf="preview.selfieFile">
            <div class="m-pageRegisterLot_fileDisplay">
              <span class="m-pageRegisterLot_fileDisplay__name">
                {{ preview.selfieFile.fileName }}
              </span>
              <button class="m-pageRegisterLot_fileDisplay__btn" (click)="removeFile('selfieFile')" type="button">
                <svg class="c-icon">
                  <use xlink:href="#ic-garbage-close" />
                </svg>
              </button>
            </div>
          </div>
        </ng-container>

        <ng-template #selfieStatusTemplate>
          <div *ngIf="documentsStatus.selfie === 'rejected' ||
              documentsStatus.selfie === 'requested'" class="s-marginTop-sm">

            <label class="m-button m-button--outline m-button--upload s-width-100" for="uploadSelfie">
              {{ preview.selfieFile ? "Arquivo anexado" : "Enviar novamente" }}
              <svg class="c-icon">
                <use xlink:href="#ic-arrow-upload" />
              </svg>
              <input accept=".jpg,.jpeg,.png" id="uploadSelfie" type="file"
                (change)="onFileChange($event, 'selfieFile')" />
            </label>

            <div class="m-pageRegisterLot_uploadedFiles s-marginTop-sm" *ngIf="preview.selfieFile">
              <div class="m-pageRegisterLot_fileDisplay">
                <span class="m-pageRegisterLot_fileDisplay__name">
                  {{ preview.selfieFile.fileName }}
                </span>
                <button class="m-pageRegisterLot_fileDisplay__btn" (click)="removeFile('selfieFile')" type="button">
                  <svg class="c-icon">
                    <use xlink:href="#ic-garbage-close" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

    </div>

    <div class="s-marginTop-mdl d-flex l-grid--end s-width-100"
      *ngIf="hasDocumentsLoaded && !areAllDocumentsApproved()">
      <button class="m-button button__register" (click)="submitDocuments()"
        [disabled]="loading || !formDocuments.valid">
        <span *ngIf="loading" class="d-flex l-grid--middle">
          <mat-spinner [diameter]="14"></mat-spinner> Enviando...
        </span>
        <span *ngIf="!loading">Salvar</span>
      </button>
    </div>
  </form>
</div>
